export interface AxItem {
  item: {
    id: string
  }
  id: string
  code: string
  name: string
  name_read: string
  content1: string
  content2: string
  categories: {
    id: number
    code: string
    name: string
  }[]
  tax_rate_sell_price: number
  tax_rate_regular_price: number
  display_period_begin: string
  display_period_end: any
  purchase_period_begin: string
  purchase_period_end: string
  sku_maximum_purchase: number
  sku_minimum_purchase: number
  disabled_notify_arrival_sku: boolean
  images: {
    url: string
    alt_text: string
  }[]
  variation: {
    id: string
    code: string
    name: string
  }[]
  custom: { [customAttr: string]: number | string | any }
  created_at: string
  updated_at: string
  skus: AxItemSku[]
}

export interface AxFavoritItem {
  item: {
    id: string
  }
  id: string
  code: string
  name: string
  name_read: string
  content1: string
  content2: string
  categories: {
    id: number
    code: string
    name: string
  }[]
  tax_rate_sell_price: number
  tax_rate_regular_price: number
  display_period_begin: string
  display_period_end: any
  purchase_period_begin: string
  purchase_period_end: string
  sku_maximum_purchase: number
  sku_minimum_purchase: number
  disabled_notify_arrival_sku: boolean
  images: {
    url: string
    alt_text: string
  }[]
  variation: {
    id: string
    code: string
    name: string
  }[]
  custom: { [customAttr: string]: number | string | any }
  created_at: string
  updated_at: string
  skus: AxItemSku
}

export interface AxItemSku {
  id: string
  code: string
  variation: {
    id: string
    code: string
    name: string
  }[]
  jan: string
  sell_price_tax_included: number
  sell_price_tax_excluded: number
  regular_price_tax_included: number
  regular_price_tax_excluded: number
  stock_quantity_infinity: boolean // 在庫無制限の場合: 1
  stock_quantity: number
  images: Image2[]
  coupon_ids: string[]
  basic_point_amount: number
  custom: { [customAttr: string]: number | string | any }
  sku_maximum_purchase: number
  sku_minimum_purchase: number
}

export interface Image2 {
  url: string
  alt_text: string
  code: string
  sortkey: number
}

/**
 * CategoryTrees
 */
export interface CategoryTrees {
  id: string
  code: string
  name: string
  root_categories: {
    id: string
    code: string
    name: string
    custom: any[]
  }[]
}

/**
 * Variation
 */
export interface variations {
  id: string
  code: string
  name: string
  selections: {
    id: string
    code: string
    name: string
  }[]
}

/**
 * UserItemReviews
 */
export interface UserItemReviews {
  id: string
  item_id: string
  item_code: string
  item_name: string
  is_published: string
  is_delete_requested: string
  histories: {
    title: string
    body: string
    item_score: string
    posted_at: string
    shop_comment: string
    shop_comment_updated_at: string
    is_published: string
    is_confirmed: string
  }[]
}
;[]

/**
 * AxItemSearchQuery
 */
export type AxItemSearchQuery = {
  query: {
    keyword?: {
      /**
       * 配下の条件リストの評価方法。条件リストのすべてを満たす必要がある場合はand を、いずれかを満たす必要がある場合は、or を設定します。
       */
      operator: 'and' | 'or'
      /**
       * キーワード検索条件リスト。
       */
      queries: {
        fields: string[] // "item.name", "item.custom.description"
        keyword: string // "りんご 人気"
      }[]
    }
    not_keyword?: {
      operator: 'and' | 'or'
      queries: {
        fields: string[] // "item.name", "item.custom.description"
        keyword: string // "ピーナッツ"
      }[]
    }
    filters?: [
      {
        operator: 'and' | 'or'
        filters: AxCategoryfilterQuery
        // [
        //   {
        //     field: string
        //     value: string
        //     compare?: '=' | '*=' | '>' | '<' | '>=' | '<=' | '!=*'
        //     or_null?: boolean
        //   }
        // ]
      }
    ]
    offset: number // 0,
    limit: number // 2,
    sorts?: [
      {
        field: string // "item.skus.sell_price_tax_included",
        reverse?: boolean // false
      }
    ]
    ignore_visibility?: boolean
  }
  request: {
    fields?: string[] // "item.id", "item.name", "item.skus.variation.size.name", "item.skus.sell_price_tax_included"
    facets?: [
      // TODO: define list
    // {
    //   field: "item.skus.variation.size",
    //   minimum_hit: 1
    // },
    // {
    //   field: "item.categories.category-1",
    //   minimum_hit: 1
    // },
    // {
    //   field: "item.skus.sell_price_tax_included",
    //   ranges: [
    //     {"to": 1000},
    //     {"from": 1000, "to": 5000},
    //     {"from": 5000}
    //   ]
    // }
    ]
  }
}

/**
 * AxCategoryfilterQuery
 */
export type AxCategoryfilterQuery = [
  {
    field: string
    value: string
    compare?: '=' | '*=' | '>' | '<' | '>=' | '<=' | '!=*'
    or_null?: boolean
  }
]

/**
 * AxItemSearchResponse
 */
export type AxItemSearchResponse = {
  hit: number
  items: AxItem[]
  facet?: {
    [facetFieldName: string]: {
      key: string
      count: number
    }[]
  }
}

/**
 * AxItemfilterCategory
 */
export interface AxItemfilterCategory {
  treeCode: string
  code: string
  id: string
}

/**
 * AxItemfilterVariation
 */
export interface AxItemfilterVariation {
  vName: string
  vCode: string
  selectCode: string
  selectId: string
  selectnName: string
}

export const itemFields = [
  'item.id',
  'item.code',
  'item.name',
  'item.name_read',
  'item.content1',
  'item.content2',
  'item.description',
  'item.categories.code',
  'item.categories.name',
  'item.category.name',
  'item.tax_rate_sell_price',
  'item.tax_rate_regular_price',
  'item.display_period_begin',
  'item.display_period_end',
  'item.purchase_period_begin',
  'item.purchase_period_end',
  'item.sku_maximum_purchase',
  'item.sku_minimum_purchase',
  'item.disabled_notify_arrival_sku',
  'item.images',
  'item.variation',
  'item.custom',
  'item.created_at',
  'item.updated_at',
  'item.skus',
  'item.skus.id',
  'item.skus.stock_quantity',
  'item.skus.stock_quantity_infinity',
  'item.skus.sell_price_tax_included',
  'item.skus.code',
  'item.skus.name',
  'item.skus.variation',
  'item.skus.variation.id',
  'item.skus.variation.code',
  'item.skus.variation.name',
  'item.skus.sell_price_tax_included',
  'item.skus.sell_price_tax_excluded',
  'item.skus.regular_price_tax_included',
  'item.skus.regular_price_tax_excluded',
  'item.skus.stock_quantity',
  'item.skus.images',
  "item.skus.custom.teiki_customer_discount",
]

/**
 * CategoryTreeFields
 */
export const categoryTreeFields = [
  'category_tree.id',
  'category_tree.code',
  'category_tree.name',
  'category_tree.root_categories.id',
  'category_tree.root_categories.code',
  'category_tree.root_categories.name',
  'category_tree.root_categories.custom',
]

/**
 * VariationFields
 */
export const VariationFields = [
  'variation.id',
  'variation.code',
  'variation.name',
  'variation.selections.id',
  'variation.selections.code',
  'variation.selections.name',
]

/**
 * UserItemReviewFields
 */
export const UserItemReviewFields = [
  'item_reviews.id',
  'item_reviews.item_id',
  'item_reviews.item_code',
  'item_reviews.item_name',
  'item_reviews.is_published',
  'item_reviews.is_delete_requested',
  'item_reviews.histories',
  'item_reviews.histories.title',
  'item_reviews.histories.body',
  'item_reviews.histories.item_score',
  'item_reviews.histories.posted_at',
  'item_reviews.histories.shop_comment',
  'item_reviews.histories.shop_comment_updated_at',
  'item_reviews.histories.is_published',
  'item_reviews.histories.is_confirmed',
]
